import React from 'react';

/**
 * PullToRefreshIndicator
 *
 * Indicateur visuel à placer en tête de page : flèche qui tourne pendant le
 * pull, spinner pendant le refresh.
 *
 * Usage : <PullToRefreshIndicator distance={d} threshold={t} loading={r} />
 */
export default function PullToRefreshIndicator({ distance, threshold = 70, loading }) {
  if (distance <= 0 && !loading) return null;

  const visible = loading || distance > 0;
  const triggered = distance >= threshold;
  const rotation = triggered ? 180 : Math.min(180, (distance / threshold) * 180);

  return (
    <div
      className="ptr-indicator"
      style={{
        height: loading ? 50 : Math.min(distance, 90),
        opacity: visible ? 1 : 0,
      }}
      aria-live="polite"
    >
      {loading ? (
        <div className="ptr-spinner" aria-label="Rafraîchissement en cours" />
      ) : (
        <div
          className="ptr-arrow"
          style={{ transform: `rotate(${rotation}deg)` }}
        >
          ↓
        </div>
      )}
      <span className="ptr-label">
        {loading ? 'Rafraîchissement…' : triggered ? 'Relâchez pour rafraîchir' : 'Tirez pour rafraîchir'}
      </span>
    </div>
  );
}
